import styled from 'styled-components'

const CheckBoxLabel = styled.label`
  font-size: 14px;
`

export default CheckBoxLabel
